module.exports = __webpack_public_path__ + "img/Penny-Hat-05.8522bde9.jpg";